import React from "react";
import {NavLink} from "react-router-dom";
import {Breadcrumbs} from "react-breadcrumbs-dynamic";
import styles from "./Breadcrumb.module.scss";
import {URLs} from "../../../util/Constants";
import classNames from "classnames";

class Breadcrumb extends React.PureComponent<any, any> {

  state = {
    marginStyle: styles.NormalPosition
  };

  componentWillMount(): void {
    this.setMarginStyle();
  }

  componentWillReceiveProps(nextProps: any, nextContext: any): void {
    this.setMarginStyle();
  }

  render() {
    return (
      <div className={classNames(styles.Breadcrumb, this.state.marginStyle)}>
        <Breadcrumbs
          separator={<> | </>}
          item={NavLink}
          finalItem={"b"}
        />
      </div>
    );
  }

  setMarginStyle = () => {
    const url = window.location.pathname;
    if (url === URLs.CARGA_DOCUMENTAL) {
      this.setState({marginStyle: styles.NavigationSmallUserCardPosition});
    } else if (url === URLs.ESTADO_DOCUMENTOS) {
      this.setState({marginStyle: styles.NavigationLargeUserCardPosition});
    } else {
      this.setState({marginStyle: styles.NormalPosition});
    }
  }
}

export default Breadcrumb;
